import { ToggleGroup, ToggleGroupItem } from "@ad3d/ui";
import { StudioContext } from "../../contexts/studio.context";
import { useSelector } from "@xstate/react";
import { CameraView, cameraMachine } from "@ad3d/state-machine";
import { ActorRefFrom } from "xstate";

function CameraToolbar({ cameraActor }: { cameraActor: ActorRefFrom<typeof cameraMachine> }) {
    const view = useSelector(cameraActor, (state) => state.context.view);

    const handleValueChange = (value: string) => {
        if (!value) return;
        cameraActor.send({ type: 'CAMERA.SET_VIEW', view: value as CameraView });
    };

    return (
        <div className="p-1 bg-background/80 backdrop-blur-sm rounded-lg border shadow-sm">
            <ToggleGroup type="single" value={view} onValueChange={handleValueChange}>
                <ToggleGroupItem value="3d" aria-label="3D View" className="h-9 w-14 p-0">
                    3D
                </ToggleGroupItem>
                <div className="w-px h-5 bg-foreground/20 mx-1 self-center" />
                <ToggleGroupItem value="front" aria-label="Front View" className="h-9 w-14 p-0">
                    Front
                </ToggleGroupItem>
                <ToggleGroupItem value="top" aria-label="Top View" className="h-9 w-14 p-0">
                    Top
                </ToggleGroupItem>
                <ToggleGroupItem value="left" aria-label="Left View" className="h-9 w-14 p-0">
                    Left
                </ToggleGroupItem>
                <ToggleGroupItem value="right" aria-label="Right View" className="h-9 w-14 p-0">
                    Right
                </ToggleGroupItem>
                <ToggleGroupItem value="back" aria-label="Back View" className="h-9 w-14 p-0">
                    Back
                </ToggleGroupItem>
            </ToggleGroup>
        </div>
    );
}

export function ViewToolbar() {
    const studioActor = StudioContext.useActorRef();
    const cameraActor = useSelector(studioActor, (state) => state.children.camera);

    if (!cameraActor ) return null;

    return (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 z-10 flex gap-2">
            <CameraToolbar cameraActor={cameraActor as ActorRefFrom<typeof cameraMachine>} />
        </div>
    );
}
